<template>
    <div class="bg-W " v-loading.fullscreen="cargando">
        <div v-if="capa" class="container bg-W">
            <el-row :gutter="0">

                <el-col :sm="8" :offset="0">
                    <HeaderCapa id="detallesSection" :card="capa"></HeaderCapa>
                    <MenuMovil :offset="'capa'" v-if="false " />
                    <div v-if="!$isMobile()" class="section-descrip-1" id="destinatarios">
                        <h2 class="h2-detalle-d">Destinatarios</h2>
                        <Destinatarios :extras="capa.capa"></Destinatarios>
                        <div style="padding:20px">
                            <el-button type="primary" size="default" @click="verCapa(capa.capa)"
                                icon="el-icon-back">Volver</el-button>
                        </div>

                    </div>

                </el-col>
                <el-col :sm="16" :offset="0">

                    <div id="detalleCom">
                        <h2 class="h2-detalle">Detalle Comisión n° {{ capa.com.id}}</h2>
                        <ComisionDetalle :capa="capa" :com="capa.com"></ComisionDetalle>
                    </div>
                    <div id="inscriptosCom"
                        v-if="getTextoTitulo(capa)">
                        <h2 class="h2-detalle">
                            {{ getTextoTitulo(capa) }}
                          
                        </h2>
                        <ComisionInscripciones :capa="capa" :com="capa.com"></ComisionInscripciones>
                    </div>
                    <div id="inscriptosCom"
                        v-if="!getTextoTitulo(capa)">
                        <h2 class="h2-detalle1">

                            La comisión no tiene movimientos
                          

                        </h2>

                    </div>
                    <el-button type="primary" style="margin:20px" size="default" @click="verCapa(capa.capa)"
                        icon="el-icon-back">Volver</el-button>
                </el-col>


            </el-row>







        </div>

    </div>
</template>

<script>
import { EventBus } from '@/event-bus'
import HeaderCapa from "@/components/capacitacion/header"

import Destinatarios from '@/components/capacitacion/Destinatarios.vue'
import ComisionDetalle from '@/components/capacitacion/ComisionDetalle.vue'
import ComisionInscripciones from '@/components/capacitacion/ComisionInscripciones.vue'
import MenuMovil from '@/components/capacitacion/MenuMovil.vue'

import { HTTP } from '@/axios'
export default {
    components: {
        HeaderCapa, Destinatarios, ComisionDetalle, MenuMovil, ComisionInscripciones
    },
    data() {
        return {
          
            tabs: 'destinatarios',
            selectId: 0,
            capa: undefined,
            detalles: undefined,
            currentDate: new Date(),
            cargando: true,
            aux: undefined,
            routeId: this.$route.params.id,
            confirmaDestinatario: false
        }
    },

    created() {


        EventBus.$on('confirmaDestinatario', (d) => {
            this.confirmaDestinatario = d

        })
        EventBus.$on('actualizarComision', (data) => {


            const index = this.capa.comisiones.findIndex(item => item.id === data.id);
            setTimeout(() => {
                this.capa.comisiones[index].inscripcion = data.inscripcion
                this.capa.comisiones[index].msj = data.msj
                this.capa.comisiones[index].msjTitle = data.msjTitle
                this.capa.comisiones[index].fecha_ins = data.fecha_ins
                this.capa.comisiones[index].cuil = data.cuil
            }, 100);


        })


        this.buscarCapa(this.$route.params.token, this.$route.params.slug, this.$route.params.com)


    },
    methods: {
        getTextoTitulo(capa)
        {
            if (capa.inscripciones && capa.inscripciones.length)
            {
                return "Incripciones comisión n°"+ capa.com.id
            }
            else{
                if (capa.preinscripciones && capa.preinscripciones.length)
                {
                    return "Preincripciones comisión n°" + capa.com.id
                }
                else{
                    return 0
                }
            }
        },
        handleClick(tab) {

            if (tab.name == 'aulas') {
                this.openLink('https://aulas.educaciontuc.gov.ar')


            }
            if (tab.name == 'superior') {
                this.openLink('https://des-tuc.infd.edu.ar/sitio')

            }


        },
        openLink(url) {
            // Abre el enlace en una nueva pestaña y regresa a "Destinatarios y comisiones"
            window.open(url, '_blank');
            this.$nextTick(() => {
                this.tabs = 'destinatarios';
            });
        },
        inscribirOtroCuil(comision) {
            console.log(comision)

            this.$alert(comision.msj + '<br><small style="color:red ">Para inscribir otro cuil, refresque la pagina</small>', comision.msjTitle + ' -  CUIL:' + comision.cuil, {
                confirmButtonText: 'ACEPTAR',
                type: 'info',
                dangerouslyUseHTMLString: true,
                callback: () => {
                    // this.buscarCapa(this.$route.params.token, this.$route.params.slug)

                }
            })


        },
        inscribir(com) {
            EventBus.$emit('verinscribir', com)
        },
        verCapa(capa) {
            // console.log('verCapa',capa);
            this.$router.push({ name: 'detalleCapa', params: { token: capa.token, nombre: capa.slug } })
        },
        buscarCapa(token, slug,com) {


            const baseURL = window.location.hostname === 'localhost' || window.location.hostname === 'paginatest.tucuman.edu.ar'
                ? '/capaTest/getDetalleCom'
                : '/capa/getDetalleCom';
            HTTP.post(baseURL, { token, slug, com })
                .then(res => {
                    this.capa = res.data
                    window.sessionStorage.setItem(token, JSON.stringify(res.data))
                    this.cargando = false
                    if (res.data && !res.data.capa) {
                        this.$alert('No tiene permisos para acceder a la url solicitada', 'OPERACIÓN INVALIDA', {
                            confirmButtonText: 'ACEPTAR',
                            type: 'error',
                            callback: () => {
                                this.$router.push('/')
                            }
                        })
                    }

                })
                .catch((e) => {
                    this.cargando = false
                    if (e.response.status === 429) {
                        this.$message({
                            message: 'Precaución, demasiadas peticiones en poco tiempo sobrecargan el servidor',
                            type: 'info',
                            showClose: false,
                            duration: 3000,
                        });

                        this.capa = JSON.parse(window.sessionStorage.getItem(this.$route.params.token))
                        // return false
                    }
                    else {
                        this.$alert('Hubo problemas para recuperar los datos, aguarde unos minutos y reintente', 'ERROR DE SERVIDOR', {
                            confirmButtonText: 'ACEPTAR',
                            type: 'error',
                            callback: () => {
                                this.$router.push('/')
                            }
                        })
                    }


                })



        }
    },


}
</script>

<style>
.sticky-radio-group {
    position: -webkit-sticky;
    /* Safari */
    position: sticky;
    top: 200px;
    z-index: 1000;
    /* Para asegurarte de que quede encima de otros elementos */
    background-color: white;
    /* Opcional: puedes cambiar el fondo */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    /* Agrega una sombra para destacar el elemento */
}
.section-descrip div{
    padding:20px

}
.section-descrip-1{
background: #fff;
border: 1px solid #EBEEF5;
}
.section-descrip{
    background: #fff;
     
}
.h2-detalle{
    background: #f1f1f1;
    padding:10px 20px;
  
}
.h2-detalle1 {
    background: #FFEBEE;
    padding: 10px 20px;

}
.h2-detalle-d {
    background: #607D8B;
    padding: 10px 20px;
    color: white;
    border: 1px solid #607D8B;

}
/* Ajustes adicionales para eliminar los bordes redondeados en todos los estados */
.no-rounded .el-radio-button__inner {
    border-radius: 0 !important;
    /* Eliminar el borde redondeado */
}

.no-rounded .el-radio-button__inner:hover {
    border-radius: 0 !important;
}

.no-rounded .el-radio-button__inner.is-active {
    border-radius: 0 !important;
}
.full-width-radio-group {
    display: flex;
    width: 100%;
}

.full-width-radio-group .el-radio-button {
    flex: 1;
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
}

.full-width-radio-group .el-radio-button .el-radio-button__inner {
    width: 100%;
    text-align: center;
}
.bg-W{
    background: #FFF;
    position: relative;
    /* overflow-y: scroll; */
}
.el-tabs--border-card {
    background: #FFF;
    border: 1px solid #DCDFE6;
    box-shadow: 0;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #686868;
    background-color: #FFF;
    border-right-color: #DCDFE6;
    border-left-color: #DCDFE6;
}

.table-datos {
    background: beige;
    width: 100%;
    border-collapse: collapse;
    /* border-radius: 8px; */
    margin-bottom: 0px;

}

.table-datos tr>td,
.table-datos tr>th {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    font-size: 14px;

}

.direccion {
    font-size: 16px;
    color: #007bff;
    margin-bottom: 8px;
}

.modalidad {
    display: inline-block;
    background-color: #17a2b8;
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    margin-bottom: 16px;
}



.table-p {
    padding: 10px 20px;
}

.table-p p {
    font-size: 14px;
    border-bottom: 1px solid #ddd;
    padding: 2px;
}
</style>

<style lang="scss" scoped>
.card-capa {
    margin-top: 20px;

}

.content-capa {
    height: calc(100vh - 480px);
    // overflow-y: scroll;
    // overflow-x: hidden;
}



.checkbox-container {
    margin: 20px auto;
    display: flex;
    align-items: center;
    background: #ff9dac;
    padding: 10px;
    font-weight: bold;
    font-family: "PT Sans", sans-serif;
}

.checkbox-container input[type="checkbox"] {
    transform: scale(1.5);
    margin-right: 10px;
}

.checkbox-container label {
    font-size: 16px;
}

.h2-detalle {
    background: #f1f1f1;
    padding: 10px 10px;
    font-size: 20px;

}

.h2-detalle1 {
    background: #FFEBEE;
    padding: 10px 10px;

}
</style>